import { render, staticRenderFns } from "./APITest.vue?vue&type=template&id=4c8dac58&"
import script from "./APITest.vue?vue&type=script&lang=js&"
export * from "./APITest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports